import LdfTab from "@features/creation/ldf/components/LdfTab";
import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { ListTree } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ldf/")({
  loader: requirePermission("creation.ldf.view"),
  staticData: {
    title: "LDF / Nomenclatures",
    icon: ListTree,
    tab_icon: ListTree,
    permission: "creation.ldf.view",
    module: "creation",
    section: "Creation",
    order: 22,
    description: "Listes de Fabrication",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: LdfTab,
});
